<template>
	<div class="county-search">
		<div class="form-group">
			<label for="countySearch">County</label>
			<input
				type="text"
				class="form-control"
				v-model="search"
				placeholder="type to search for county"
				id="countySearch"
			/>
		</div>
		<div class="search-results-container position-relative">
			<div class="search-results position-absolute bg-white rounded shadow-sm" style="z-index:999">
				<template v-if="!loading">
					<template v-if="counties.length > 0">
						<div
							v-for="county in counties"
							:key="county.id"
							@click="setCounty(county)"
							class="search-item ps-2 pe-2 py-1 d-flex"
						>
							<span class="me-2 w-50">{{ county.name }}</span>
							<span class="me-2 w-25">{{ county.county_seat }}</span>
							<span class="w-25 text-end pe-2">{{ county.state }}</span>
						</div>
					</template>
					<template v-if="counties.length === 0 && search.length > 1">
						<span class="me-2 ms-2">County not found!</span>
					</template>
				</template>
				<template v-else>
					<div class="d-flex justify-content-center p-2">
						<div class="spinner-border spinner-border-sm" role="status">
							<span class="sr-only">Loading...</span>
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import restApi from '../../api/index'
import { handleErrors } from '../../actions/helpers'

export default {
	name: 'CountyAdvancedSearch',
	data() {
		return {
			loading: false,
			counties: [],
			search: '',
		}
	},
	methods: {
		getCounties() {
			this.loading = true
			restApi
				.get('/counties', { params: { search: this.search, perPage: 20 } })
				.then(({ data }) => {
					this.loading = false
					this.counties = data.data || []
				})
				.catch(error => {
					this.loading = false
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		setCounty(county) {
			this.counties = []
			this.search = ''
			this.$emit('setCounty', county)
		},
	},
	watch: {
		search() {
			if (this.search.length >= 2) {
				if (!this.loading) {
					this.getCounties()
				}
			} else {
				this.counties = []
			}
		},
	},
}
</script>

<style lang="scss">
.county-search {
	.search-results-container {
		.search-results {
			width: 100%;
			.search-item {
				cursor: pointer;
				&:hover {
					background-color: whitesmoke;
					border-radius: 0.5rem;
				}
			}
		}
	}
}
</style>
